import React from 'react';
import MapMain from '../components/MapMain';
import Navbar from '../components/Navbar';

const Map: React.FC = () => {
  return (
    <div className="w-screen h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="w-full h-full max-w-(--breakpoint-lg) p-2">
            <MapMain />
        </div>
        </main>
    </div>
  );
};

export default Map;